import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { PrimaryButton as FluentUIPrimaryButton } from '@fluentui/react';

import { BaseButton } from '../BaseButton';
import { IButtonImplProps } from '../BaseButton.types';

export const PrimaryButton = (props: IButtonImplProps) => <BaseButton componentAs={FluentUIPrimaryButton} {...props} />;
